import type { ICountryObject } from "app/services/CountryService";
import { DefaultFetchService } from "app/services/fetchService";
import { devicesTypes } from "app/UtilitiesAndConstants/Constants/DevicesTypes";

import type { Keyword } from "../types";

export const KEYWORDS_VOLUMES_PATHNAME = "api/MarketResearch/DemandSearchTrends/KeywordsVolumes";
const API_DELIMITER = ",";

type APIKeyword = {
    Keyword: string;
    AverageVolume: number;
};

type APIKeywords = Record<string, APIKeyword>;

interface Result {
    Data: APIKeywords;
}

export const getEnrichedKeywords = async (
    keywords: Keyword[],
    country: ICountryObject,
    signal?: AbortSignal,
): Promise<Keyword[]> => {
    const fetchService = DefaultFetchService.getInstance();
    const params = {
        websource: devicesTypes.TOTAL,
        keywords: keywords.map(({ term }) => term).join(API_DELIMITER),
        country: country.id,
    };
    return fetchService.get<Result>(KEYWORDS_VOLUMES_PATHNAME, params, { cancellation: signal }).then((response) => {
        return Object.keys(response.Data).map((key) => {
            const { Keyword: term, AverageVolume: volume } = response.Data[key];
            return {
                term,
                volume,
            };
        });
    });
};
